<template>
  <div class="dashboard-container">
    <div class="top-search">
      <div class="search">
        <!-- <div class="title">搜索</div> -->
        <div class="content">
          <el-date-picker
            v-model="timeWrap"
            type="datetimerange"
            align="right"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['12:00:00', '08:00:00']"
          ></el-date-picker>
          <div class="right-btns">
            <el-button type="primary" round class="search-btn" @click="search">搜索</el-button>
            <el-button round class="reset-btn" style="margin-left:20px;" @click="reset">重置</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="table-container">
      <el-table
        :data="tableData"
        empty-text="暂无数据"
        style="width: 100%"
        height="600"
        :row-style="{background: '#FCFDFF'}"
        :header-cell-style="{background:'#2d3a5b',color:'#ffffff'}"
      >
        <el-table-column align="center" label="时间" width="120">
          <template slot-scope="scope">
            <span>{{scope.row.date}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="日活" width="100">
          <template slot-scope="scope">
            <span>${{scope.row.name | priceFilter}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="服务器成本（预估）" width="150">
          <template slot-scope="scope">
            <span>${{scope.row.name | priceFilter}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="营销成本">
          <template slot-scope="scope">
            <span>${{scope.row.name | priceFilter}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="总成本">
          <template slot-scope="scope">
            <span>${{scope.row.name | priceFilter}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="广告收入">
          <template slot-scope="scope">
            <span>${{scope.row.name | priceFilter}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="内购收入">
          <template slot-scope="scope">
            <span>${{scope.row.name | priceFilter}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="广告收入-总成本" width="150">
          <template slot-scope="scope">
            <span>${{scope.row.name | priceFilter}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="总收入">
          <template slot-scope="scope">
            <span>${{scope.row.name | priceFilter}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="项目毛利">
          <template slot-scope="scope">
            <span>$ {{scope.row.name | priceFilter}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination
      :total="pagination.total"
      :size="pagination.size"
      :pageSize="pagination.pageSize"
      @pagination="getData()"
    ></pagination>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Pagination from "@/components/Pagination";
// import { getList } from "@/api/project.js";
export default {
  name: "Dashboard",
  components: { Pagination },
  computed: {
    ...mapGetters(["name"])
  },
  filters: {
    priceFilter: function name(num) {
      const price = num / 10;
      return price.toString().indexOf(".") !== -1
        ? price.toLocaleString()
        : price.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
    }
  },
  data() {
    return {
      timeWrap: "",
      pagination: {
        pageSize: 10,
        page: 1,
        total: 20
      },
      tableData1: [],
      tableData: [
        {
          date: "2016-05-02",
          name: 3000,
          address: "上海市普陀区金沙江路 1518 弄"
        },
        {
          date: "2016-05-04",
          name: 1000,
          address: "上海市普陀区金沙江路 1517 弄"
        },
        {
          date: "2016-05-01",
          name: 1000,
          address: "上海市普陀区金沙江路 1519 弄"
        },
        {
          date: "2016-05-03",
          name: 1000,
          address: "上海市普陀区金沙江路 1516 弄"
        },
        {
          date: "2016-05-02",
          name: 1000,
          address: "上海市普陀区金沙江路 1518 弄"
        },
        {
          date: "2016-05-04",
          name: 1000,
          address: "上海市普陀区金沙江路 1517 弄"
        },
        {
          date: "2016-05-01",
          name: 1000,
          address: "上海市普陀区金沙江路 1519 弄"
        },
        {
          date: "2016-05-03",
          name: 1000,
          address: "上海市普陀区金沙江路 1516 弄"
        },
        {
          date: "2016-05-02",
          name: 1000,
          address: "上海市普陀区金沙江路 1518 弄"
        },
        {
          date: "2016-05-04",
          name: 1000,
          address: "上海市普陀区金沙江路 1517 弄"
        },
        {
          date: "2016-05-01",
          name: 1000,
          address: "上海市普陀区金沙江路 1519 弄"
        },
        {
          date: "2016-05-03",
          name: 600,
          address: "上海市普陀区金沙江路 1516 弄"
        }
      ]
    };
  },
  watch: {},
  created() {
    // console.log(this.$route.meta.id);
    // getList({id: this.$route.meta.id}).then(res => {
    //   console.log(res);
    // })
  },
  methods: {
    getData() {},
    handleCurrentChange() {},
    search() {},
    reset() {}
  }
};
</script>

<style lang="scss" scoped>
@mixin flex($ali, $jus) {
  display: flex;
  align-items: $ali;
  justify-content: $jus;
}

.dashboard-container{
  margin: 20px;
}

.top-search {
  display: flex;
  padding: 20px 20px 0;
  width: 100%;
  // height: 100px;
  background: #ffffff;
  border: 1px solid #f0f3f7;
}
.table-container {
  min-height: 400px;
  margin-top: 20px;
  width: 100%;
  // border-radius: 10px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 #eff2f7;
}
.search {
  // width: 1160px;
  // height: 160px;
  width: 100%;
  background: #ffffff;
  border-radius: 10px;
  // margin: 0 auto;
  overflow: hidden;
  .content {
    @include flex(center, space-between);
    border-radius: 4px;
    height: 76px;
    width: 100%;
    margin: 0 auto;
  }
}
.pageContain {
  @include flex(center, flex-end);
  margin-top: 20px;
}
.search-btn {
  background-color: #2d3a5b;
  border: #2d3a5b;
}
.reset-btn {
  background-color: #ffffff;
  color: #2d3a5b;
  border: 1px solid #2d3a5b;
}
</style>
